import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import SidebarStore from './SidebarStore';
import DockToRightIcon from './assets/DockToRight.svg';

const SidebarToggle: React.FC = () => (
  <button
    type="button"
    className={classNames('app-sidebar__toggle', {
      'app-sidebar__toggle_collapsed': SidebarStore.collapsed
    })}
    onClick={SidebarStore.toggle}
    aria-label={SidebarStore.collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
  >
    <DockToRightIcon />
  </button>
);

export default observer(SidebarToggle);
